import moment from "moment";
import _ from "lodash";
export const momentable = (value, format) => {
    return Array.isArray(value) ? value.map(val => moment(val, format)) : value ? moment(value, format) : value;
};

export const formatMomentValue = (value, format, placeholder) => {
    const formatDate = (date, format, i = 0) => {
        if (!date) return placeholder;
        if (Array.isArray(format)) {
            const _format = format[i];
            if (_.isFunction(_format)) {
                return _format(date);
            }
            if (_.isEmpty(_format)) {
                return date;
            }
            return moment(date).format(_format);
        } else {
            if (_.isFunction(format)) {
                return format(date);
            }
            if (_.isFunction(format)) {
                return date;
            }
            return moment(date).format(format);
        }
    };
    if (Array.isArray(value)) {
        return value.map((val, index) => {
            return formatDate(val, format, index);
        });
    } else {
        return value ? formatDate(value, format) : value || placeholder;
    }
};
